import asyncComponent from '../../components/AsyncComponent';

const CourseEditor = asyncComponent(() => import('../../containers/Course/Editor'));

export default CourseEditor;
